import { pxToRem } from '../../../../utils';
export var imageVariables = function imageVariables() {
  return {
    width: undefined,
    height: undefined,
    avatarRadius: pxToRem(9999),
    avatarSize: pxToRem(32),
    circularRadius: pxToRem(9999)
  };
};